function HomeIcon() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_316_278)">
        <path
          d="M4.24512 12.0816L16.0002 2.93878L27.7553 12.0816V26.449C27.7553 27.1418 27.4801 27.8062 26.9902 28.2961C26.5003 28.786 25.8359 29.0612 25.1431 29.0612H6.85736C6.16455 29.0612 5.50012 28.786 5.01023 28.2961C4.52033 27.8062 4.24512 27.1418 4.24512 26.449V12.0816Z"
          stroke="#745FF2"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.0815 29.0612V16H19.9183V29.0612"
          stroke="#745FF2"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_316_278">
          <rect
            width="31.3469"
            height="31.3469"
            fill="white"
            transform="translate(0.32666 0.326538)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export default HomeIcon;
